import { useState, useEffect } from 'react'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function AdminPanel() {
  const [buyRate, setBuyRate] = useState('')
  const [sellRate, setSellRate] = useState('')
  const [currentRate, setCurrentRate] = useState(null)
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(false)
  const [token, setToken] = useState(localStorage.getItem('adminToken') || null)
  const [password, setPassword] = useState('')
  const [loginError, setLoginError] = useState('')

  useEffect(() => {
    if (token) {
      loadCurrentRate()
      loadHistory()
    }
  }, [token])

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoginError('')
    // Validar la contraseña contra el backend — nunca en el cliente
    try {
      const response = await fetch(`${API_URL}/api/rates`, {
        headers: { 'Authorization': `Bearer ${password}` }
      })
      // Intentamos una llamada protegida; si regresa 401 la contraseña es incorrecta
      const testAuth = await fetch(`${API_URL}/api/rates/history`, {
        headers: { 'Authorization': `Bearer ${password}` }
      })
      if (testAuth.ok) {
        localStorage.setItem('adminToken', password)
        setToken(password)
        setPassword('')
      } else {
        setLoginError('Contraseña incorrecta')
      }
    } catch {
      setLoginError('No se pudo conectar al servidor')
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('adminToken')
    setToken(null)
    setPassword('')
  }

  const loadCurrentRate = async () => {
    try {
      const response = await fetch(`${API_URL}/api/rates`)
      const data = await response.json()
      setCurrentRate(data)
      setBuyRate(data.buy)
      setSellRate(data.sell)
    } catch (error) {
      console.error('Error al cargar tasa actual:', error)
    }
  }

  const loadHistory = async () => {
    try {
      const response = await fetch(`${API_URL}/api/rates/history`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      if (response.ok) {
        const data = await response.json()
        setHistory(data)
      } else if (response.status === 401) {
        handleLogout()
      }
    } catch (error) {
      console.error('Error al cargar historial:', error)
    }
  }

  const handleSave = async () => {
    if (!buyRate || !sellRate) {
      alert('Por favor ingresa ambos valores')
      return
    }

    setLoading(true)
    try {
      const response = await fetch(`${API_URL}/api/rates`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          buy: parseFloat(buyRate),
          sell: parseFloat(sellRate)
        })
      })

      const result = await response.json()

      if (response.status === 401) {
        handleLogout()
        alert('Sesión expirada. Por favor inicia sesión de nuevo.')
        return
      }

      if (result.success) {
        alert('¡Tasa guardada correctamente!')
        loadCurrentRate()
        loadHistory()
      } else {
        alert('Error al guardar: ' + result.error)
      }
    } catch (error) {
      alert('Error de conexión')
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  // Login UI
  if (!token) {
    return (
      <div style={{ padding: '40px', maxWidth: '400px', margin: '50px auto', background: '#f5f5f5', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ background: 'white', borderRadius: '8px', padding: '40px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', width: '100%' }}>
          <h1 style={{ color: '#c62b2b', marginBottom: '10px', textAlign: 'center' }}>Acceso Admin</h1>
          <p style={{ color: '#666', marginBottom: '30px', textAlign: 'center' }}>Ingresa la contraseña para continuar</p>

          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Contraseña:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa la contraseña"
                autoFocus
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '16px',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            {loginError && (
              <div style={{ color: '#d32f2f', marginBottom: '15px', padding: '10px', background: '#ffebee', borderRadius: '4px' }}>
                {loginError}
              </div>
            )}

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '12px',
                background: '#c62b2b',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer',
                marginBottom: '15px'
              }}
            >
              Ingresar
            </button>
          </form>

          <a href="/" style={{ display: 'block', textAlign: 'center', color: '#c62b2b', textDecoration: 'none' }}>
            Volver a la página principal
          </a>
        </div>
      </div>
    )
  }

  return (
    <div style={{ padding: '40px', maxWidth: '1000px', margin: '0 auto', background: '#f5f5f5', minHeight: '100vh' }}>
      {/* Botón de cerrar sesión */}
      <div style={{ marginBottom: '20px', textAlign: 'right' }}>
        <button
          onClick={handleLogout}
          style={{
            padding: '8px 16px',
            background: '#999',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Cerrar Sesión
        </button>
      </div>

      {/* Card Principal */}
      <div style={{ background: 'white', borderRadius: '8px', padding: '30px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h1 style={{ color: '#c62b2b', marginBottom: '10px' }}>Panel de Administración</h1>
        <p style={{ color: '#666', marginBottom: '30px' }}>Del Sol Centro Cambiario</p>

        {/* Tasa Actual */}
        {currentRate && (
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '4px', borderLeft: '4px solid #c62b2b', marginBottom: '30px' }}>
            <h3 style={{ color: '#c62b2b', marginBottom: '10px' }}>Tasa Actual en la Página:</h3>
            <div style={{ display: 'flex', gap: '30px', fontSize: '18px' }}>
              <div>Compra: <strong style={{ color: '#c62b2b' }}>${currentRate.buy}</strong></div>
              <div>Venta: <strong style={{ color: '#c62b2b' }}>${currentRate.sell}</strong></div>
              <div style={{ color: '#666', fontSize: '14px' }}>{currentRate.lastUpdate}</div>
            </div>
          </div>
        )}

        {/* Formulario */}
        <h3 style={{ marginBottom: '20px' }}>Actualizar Tipo de Cambio:</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>Compra USD:</label>
            <input
              type="number"
              step="0.0001"
              value={buyRate}
              onChange={(e) => setBuyRate(e.target.value)}
              placeholder="19.8000"
              style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>Venta USD:</label>
            <input
              type="number"
              step="0.0001"
              value={sellRate}
              onChange={(e) => setSellRate(e.target.value)}
              placeholder="20.2000"
              style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px' }}
            />
          </div>
        </div>

        <button
          onClick={handleSave}
          disabled={loading}
          style={{
            width: '100%',
            padding: '15px',
            background: loading ? '#ccc' : '#c62b2b',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Guardando...' : 'Guardar Nueva Tasa'}
        </button>

        <a href="/" style={{ display: 'inline-block', marginTop: '20px', color: '#c62b2b', textDecoration: 'none' }}>
          Volver a la página principal
        </a>
      </div>

      {/* Historial */}
      <div style={{ background: 'white', borderRadius: '8px', padding: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ marginBottom: '20px' }}>Historial de Tasas</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8f9fa' }}>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Fecha y Hora</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Compra</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Venta</th>
            </tr>
          </thead>
          <tbody>
            {history.map((rate) => (
              <tr key={rate.id} style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '12px' }}>{rate.date}</td>
                <td style={{ padding: '12px' }}>${rate.buy}</td>
                <td style={{ padding: '12px' }}>${rate.sell}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}